// App.js
import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';
import Fountain from './Fountain';
import Tinder from './Tinder';
import Implicit from './Implicit';
import Dashboard from './Dashboard';
import ViewBoards from './ViewBoards';
import Map from './Map'; // Import the new Map component
import SessionReview from './SessionReview';
import SessionsList from './SessionsList';

function AppRoutes() {
  const location = useLocation();

  useEffect(() => {
    try {
      fetch('/api/track', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          path: location.pathname,
          referrer: document.referrer || null,
        }),
      }).catch(() => {});
    } catch (e) {
      // Silently ignore tracking failures
    }
  }, [location]);

  return (
    <Routes>
      <Route path="/" element={<Fountain />} />
      <Route path="/tinder" element={<Tinder />} />
      <Route path="/implicit" element={<Implicit />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/map" element={<Map />} /> {/* Add the Map route */}
      <Route path="/sessions" element={<SessionsList />} />
      <Route path="/s/:code" element={<SessionReview />} />
      <Route path="/session-review" element={<SessionReview />} />
      <Route path="/:username" element={<ViewBoards />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <AppRoutes />
      </div>
    </BrowserRouter>
  );
}

export default App;
